/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shadows_LabelInputs */

const en_shadows_label = /** @type {(inputs: Shadows_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shadows`)
};

const fr_shadows_label = /** @type {(inputs: Shadows_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ombres`)
};

const ms_sg2_shadows_label = /** @type {(inputs: Shadows_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bayang`)
};

/**
* | output |
* | --- |
* | "Shadows" |
*
* @param {Shadows_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const shadows_label = /** @type {((inputs?: Shadows_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shadows_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shadows_label(inputs)
	if (locale === "fr") return fr_shadows_label(inputs)
	return ms_sg2_shadows_label(inputs)
});